import React, { useEffect, useState } from 'react';
//import { servicios } from '../../json/organismos';
import './organismos.css';
import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';

const Comite = () => {

    const [modal, setModal] = useState({
        ver: false,
        id: 0,
    })

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Comités</h3>
                <hr className='hr-gob'/>
            </div>
            <div className='organismos'>
                {
                    window._my_comites.filter(p => p.ver>0).map((item, i)=>(
                        <div className="puntero" key={i} onClick={() => {
                          setModal({
                            ver: true,
                            id: item.id,
                          })
                        }}>
                            <h5 className='title'>{item.nombre}</h5>
                            <p>{item.objetivo}</p>
                            <ccc className="mas">Ver más</ccc>
                        </div>
                    ))
                }
            </div>
            <div id="mi_espacio"/>
        </div>
        <Modal
            show={modal.ver}
            size="lg"
            centered
            onHide={() => {
                setModal({
                    ver: false,
                    id: 0,
                })
            }}
        >
            <Modal.Header closeButton>
              <Modal.Title>
                {
                    window._my_comites.filter(p => p.id===modal.id).length>0 ?
                        window._my_comites.filter(p => p.id===modal.id)[0].nombre
                    :
                        null
                }
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                  {
                    window._my_comites.filter(p => p.id === modal.id).map(item =>
                      <table className="tabla_organismos">
                        <tr>
                          <td>Nombre</td>
                          <td>{item.nombre}</td>
                        </tr>
                        <tr>
                          <td>Siglas</td>
                          <td>{item.siglas}</td>
                        </tr>
                        <tr>
                          <td>Objetivo</td>
                          <td><div dangerouslySetInnerHTML={{ __html: item.objetivo }} className="comite_objetivo"/></td>
                        </tr>
                        {
                          item.integrantes.length>0 ?
                            <tr>
                              <td>Integrantes</td>
                              <td>
                                {
                                  item.integrantes.map((item, i) =>
                                    <div>
                                      <h14>{item.nombre}</h14>
                                      <br/>
                                      <i>{item.puesto}</i>
                                    </div>
                                  )
                                }
                              </td>
                            </tr>
                          :
                            null
                        }
                        {
                          item.infografia ?
                            <tr>
                              <td>Infografía</td>
                              <td>
                                <div className="web_modal_organismos">
                                  <a href={item.infografia} target="new" className="mas">
                                    Ver infografía
                                  </a>
                                </div>
                              </td>
                            </tr>
                          :
                            null
                        }
                        {
                          item.documento ?
                            <tr>
                              <td>Documento</td>
                              <td>
                                <div className="web_modal_organismos">
                                  <a href={item.documento} target="new" className="mas">
                                    Documento 
                                  </a>
                                </div>
                              </td>
                            </tr>
                          :
                            null
                        }
                        {
                          item.arreglo.length>0 ?
                            <tr>
                              <td colspan="2">
                                <Accordion>
                                  {
                                    item.arreglo.map((nor, n) =>
                                      <Accordion.Item eventKey={n}>
                                        <Accordion.Header>{nor.norma}</Accordion.Header>
                                        <Accordion.Body>
                                          {
                                            nor.archivos.length>0 ?
                                              nor.archivos.map((arc, s) =>
                                                <div className="acor_normateca" key={s}>
                                                  <div>{arc.titulo}</div>
                                                  <a href={arc.link} target="new" className="mas">Documento</a>
                                                </div>
                                              )
                                            :
                                              null
                                          }
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    )
                                  }
                                </Accordion>
                              </td>
                            </tr>
                          :
                            null
                        }
                      </table>
                    )
                  }
                </div>
            </Modal.Body>
        </Modal>
    </div>
  )
}

export default Comite